import { loadCookieNotice } from "./storage";

export const isCookieDeclined = () => loadCookieNotice() === "cancel";
